import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useScroll, motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
const menuItems = [{
  name: 'What We Do',
  href: '/what-we-do'
}, {
  name: 'About Us',
  href: '/about'
}, {
  name: 'Services',
  href: '/services'
}, {
  name: 'Team',
  href: '/team'
}, {
  name: 'Contact',
  href: '/contact'
}, {
  name: 'What is MDM?',
  href: '/what-is-mdm'
}];
export const Header = () => {
  const [menuState, setMenuState] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  const location = useLocation();
  useEffect(() => {
    const unsubscribe = scrollYProgress.on('change', latest => {
      setScrolled(latest > 0.05);
    });
    return () => unsubscribe();
  }, [scrollYProgress]);
  const handleLogoClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <header data-id="element-23">
      <nav data-state={menuState ? 'active' : 'inactive'} className="group fixed z-50 w-full pt-2" data-id="element-24">
        <div className={`mx-auto max-w-7xl rounded-3xl px-6 transition-all duration-300 lg:px-12 ${scrolled ? 'bg-black/80 backdrop-blur-2xl' : ''}`} data-id="element-25">
          <motion.div className={`relative flex flex-wrap items-center justify-between gap-6 py-3 duration-200 lg:gap-0 lg:py-6 ${scrolled ? 'lg:py-4' : ''}`} data-id="element-26">
            <div className="flex w-full items-center justify-between gap-12 lg:w-auto" data-id="element-27">
              <Link to="/" aria-label="home" className="flex items-center space-x-2" onClick={handleLogoClick} data-id="element-28">
                <Logo data-id="element-29" />
              </Link>
              <button onClick={() => setMenuState(!menuState)} aria-label={menuState ? 'Close Menu' : 'Open Menu'} className="relative z-50 -m-2.5 -mr-4 block cursor-pointer p-2.5 lg:hidden" data-id="element-30">
                <Menu className={`m-auto size-6 duration-200 text-white ${menuState ? 'rotate-180 scale-0 opacity-0' : ''}`} data-id="element-31" />
                <X className={`absolute inset-0 m-auto size-6 duration-200 text-white ${menuState ? 'rotate-0 scale-100 opacity-100' : '-rotate-180 scale-0 opacity-0'}`} data-id="element-32" />
              </button>
              <div className="hidden lg:block" data-id="element-33">
                <ul className="flex gap-8 text-sm" data-id="element-34">
                  {menuItems.map((item, index) => <li key={index} data-id="element-35">
                      <Link to={item.href} className={`block duration-300 ${location.pathname === item.href ? 'text-white' : 'text-white/70 hover:text-purple-400'}`} data-id="element-36">
                        <span data-id="element-37">{item.name}</span>
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className={`bg-black/95 backdrop-blur-xl mb-6 w-full flex-wrap items-center justify-end space-y-8 rounded-3xl border border-white/10 p-6 shadow-2xl md:flex-nowrap lg:m-0 lg:flex lg:w-fit lg:gap-6 lg:space-y-0 lg:border-transparent lg:bg-transparent lg:p-0 lg:shadow-none ${menuState ? 'flex' : 'hidden lg:flex'}`} data-id="element-38">
              <div className="lg:hidden" data-id="element-39">
                <ul className="space-y-6 text-base" data-id="element-40">
                  {menuItems.map((item, index) => <li key={index} data-id="element-41">
                      <Link to={item.href} className={`block duration-300 ${location.pathname === item.href ? 'text-white' : 'text-white/70 hover:text-purple-400'}`} onClick={() => setMenuState(false)} data-id="element-42">
                        <span data-id="element-43">{item.name}</span>
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </nav>
    </header>;
};
const Logo = () => {
  return <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bWFakPm72iGj7zFK9vUdN4/vantaeg2.png" alt="ProviderMDM" className="h-10 w-auto" whileHover={{
    scale: 1.1
  }} transition={{
    duration: 0.2
  }} data-id="element-44" />;
};